import produce from "immer"
import { ASC } from "const"
import { MarkovState } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovState: MarkovState = {
    id: null,
    modelId: null,
    name: "",
    description: "",
    order: 0,
}

const initMarkovStateState: types.MarkovStateState = {
    stateList: {},
    stateIds: [],
    stateEdit: initMarkovState,

    sortColumn: "order",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const markovStateReducer = produce((
    draft: types.MarkovStateState = initMarkovStateState,
    action: ActionTypes = null,
): types.MarkovStateState => {
    switch (action.type) {
        case types.MARKOV_STATE_LIST:
            draft.stateList = action.stateList
            return draft

        case types.MARKOV_STATE_IDS:
            draft.stateIds = action.stateIds
            return draft

        case types.MARKOV_STATE_EDIT:
            draft.stateEdit = action.state
            return draft

        case types.MARKOV_STATE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_STATE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MARKOV_STATE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_STATE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovStateReducer
